module.exports = __webpack_public_path__ + "img/Group.2adfa775.png";